import axios from "../../app/common/libs/http";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchOfflineMessages = createAsyncThunk(
  "offlineMessages/getOfflineMessages",
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/conversation/getOfflineMessages`,
      payload
    )
);
